import { Card, Flex } from '@radix-ui/themes';
import { JsonViewer } from 'components/common/json/json-viewer';
import { MachineContext } from 'contexts/machine.context';
import { useContext } from 'react';

export const RawDataTab = () => {
  const { healthCheckResults } = useContext(MachineContext);

  return (
    <Flex direction="column">
      <Card>
        <JsonViewer value={healthCheckResults} collapse={1} rootName="data" />
      </Card>
    </Flex>
  );
};
